import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, withState } from 'recompose'

import * as profileSelectors from 'app/modules/profile/selectors'
import * as actions from 'app/modules/meetings/actions'

import MeetingTypeListItem from './component'

function makeMapStateToProps() {
  return state => ({
    profileUrl: profileSelectors.profileUrl(state),
    profileUrlHandle: profileSelectors.profileUrlHandle(state),
    profileVisibility: profileSelectors.visibility(state),
  })
}

function mapDispatchToProps(dispatch, props) {
  return {
    actions: bindActionCreators(
      {
        deleteMeetingType: actions.deleteMeetingType,
        updateSettings: props.isDefault ? actions.debounceUpdateMeetingSettings : actions.updateMeetingType,
        fetchMeetingTypes: actions.fetchMeetingTypes,
      },
      dispatch
    ),
  }
}

export default compose(
  connect(makeMapStateToProps, mapDispatchToProps),
  withState('isDeleting', 'setIsDeleting', false),
  withState('isCopied', 'setIsCopied', false),
  withHandlers({
    handleCopyMeetingLink: props => () => {
      props.setIsCopied(true)

      setTimeout(() => {
        props.setIsCopied(false)
      }, 2000)
    },
    handleDeleteMeetingType: ({ actions, setIsDeleting, settings }) => () => {
      setIsDeleting(true)
      actions.deleteMeetingType(settings.slug)
    },
  }),
  withRouter
)(MeetingTypeListItem)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/MeetingTypesListItem/index.js